import { notification } from 'antd';
import { history } from 'index';
import * as $ from 'jquery'

const handleError = (errorData, values, title, notify, navigateTo) => {
  $('.c-handle-error').remove();
  if (errorData.errors) {
    const keys = Object.keys(errorData.errors)
    keys.forEach(key => {
      const pkey = key.split(',').pop();
      const eKey = values ? values[pkey] : pkey
      console.log(eKey, errorData.errors[key])
      if ($(`.custom-page-form [name=${eKey}],.auth-form [name=${eKey}]`).length > 0) $(`.custom-page-form [name=${eKey}],.auth-form [name=${eKey}]`).after(`<div class="c-handle-error" style="display: block; font-size: 0.9rem; color: #f44336; margin-top: 0.25em;">${errorData.errors[key] && errorData.errors[key][0]}</div>`)
    });
  } else {
    if (notify) {
      notification[notify.type]({
        message: notify.message || 'Error',
        description: notify.description || 'Oops, something went wrong!'
      })
    }
    notification.error({
      message: title || 'Error',
      description: errorData.message || 'Oops, something went wrong!'
    })
  }
  if(navigateTo) history.push(navigateTo)
}

export default handleError
